var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8184_9425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26514 10.0007C7.26514 12.106 9.54422 13.4219 11.3675 12.3692C12.2136 11.8806 12.735 10.9778 12.735 10.0007C12.735 7.89537 10.4559 6.57954 8.63264 7.63221C7.78647 8.12079 7.26514 9.02362 7.26514 10.0007Z",
    stroke: "#52616C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2791 0.882812H7.72093V3.0689C6.76701 3.38315 5.88834 3.89123 5.14009 4.56123L3.24393 3.46723L0.964844 7.41456L2.85926 8.50856C2.65484 9.49173 2.65484 10.5064 2.85926 11.4896L0.96576 12.5836L3.24484 16.5309L5.14009 15.4369C5.88809 16.1068 6.76643 16.6149 7.72001 16.9292V19.1153H12.2782V16.9292C13.2324 16.6151 14.1114 16.1071 14.8599 15.4369L16.7561 16.5309L19.0352 12.5836L17.1408 11.4896C17.345 10.5064 17.345 9.49173 17.1408 8.50856L19.0343 7.41456L16.7552 3.46723L14.8599 4.56123C14.1117 3.89123 13.233 3.38315 12.2791 3.0689V0.882812Z",
    stroke: "#52616C",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8184_9425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSetting);
export default __webpack_public_path__ + "static/media/userSetting.4dd5d68dce0f23dd47b502937e9530af.svg";
export { ForwardRef as ReactComponent };